import { RankIcon } from 'src/components/insights/icons/rank'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import dynamic from 'next/dynamic'
import preview from 'src/assets/images/widgets-previews/percentile-within-brand.png'

const BrandPercentileRanking = dynamic(
  () => import('src/components/insights/rank/percentile-ranking/by-brand-for-report'),
  {
    ssr: false,
  }
)

const CategoryPercentileRanking = dynamic(
  () => import('src/components/insights/rank/percentile-ranking/by-category-for-report'),
  {
    ssr: false,
  }
)

export const BrandPercentileRankingWidget: InsightBuilderWidget = {
  id: 'percentile-ranking',
  name: 'Percentile Ranking',
  type: 'Rank',
  icon: RankIcon,
  component: BrandPercentileRanking,
  supportedResultTypes: ['alphamap-location'],
  preview,
  minTier: 'intermediate',
}

export const CategoryPercentileRankingWidget: InsightBuilderWidget = {
  id: 'category-percentile-ranking',
  name: 'Percentile Ranking for Relevant Categories',
  type: 'Category Rank',
  icon: RankIcon,
  component: CategoryPercentileRanking,
  supportedResultTypes: ['alphamap-location'],
  preview,
  minTier: 'intermediate',
}
